var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-tabs tw-mt-2"},[_c('ul',{staticClass:"tw--mb-px tw-flex tw-space-x-6"},_vm._l((_vm.tabs),function(tab,tabKey){return _c('li',{key:tabKey},[_c('button',{class:{
          'tw-text-base tw-inline-block tw-px-1 tw-py-3 tw-border-0 tw-border-b-2 tw-border-solid tw-text-gray-500 tw-text-opacity-75 hover:tw-text-opacity-100': true,
          'tw-border-transparent hover:tw-border-separator hover:tw-border-gray-200':
            tab.handle !== _vm.activeTab,
          'tw-text-blue-600 tw-border-blue-600 tw-text-opacity-100':
            tab.handle === _vm.activeTab,
        },on:{"click":function($event){return _vm.$emit('tab-click', tab.handle)}}},[_vm._v("\n        "+_vm._s(tab.name)+"\n      ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }